import MaterialTable, { MTableToolbar } from 'material-table';
import React, { Component } from 'react';
import { UsageTable } from './UsageTable';
import { getBaseUrlFromConfig } from '../utils/url_helpers';
import { Icon } from '@avalara/skylab-react';

var config = require('../config');

const salesforceBaseURL = getBaseUrlFromConfig(config.salesforce);

export default class ObligationTable extends Component {
  expandAllHandler = (tableRef: any, length: number) => {
    for (let i = 0; i < length; i++) {
      if (!tableRef.current?.state?.renderData[i]?.tableData?.showDetailPanel) {
        tableRef.current.onToggleDetailPanel(
          [i],
          tableRef.current.props.detailPanel
        );
      }
    }
  };

  collapseAllHandler = (tableRef: any, length: number) => {
    for (let i = 0; i < length; i++) {
      if (tableRef.current?.state?.renderData[i]?.tableData?.showDetailPanel) {
        tableRef.current.onToggleDetailPanel(
          [i],
          tableRef.current.props.detailPanel
        );
      }
    }
  };

  render() {
    const data = (this.props as any).obligationSummaries.map((o: any) => {
      return {
        access: o.accessStart,
        term: ` ${o.termStart} - ${o.termEnd} `,
        termEnd: o.termEnd,
        termStart: o.termStart,
        deliverySystem: o.featureDetail.feature.canonicalName,
        name: o.featureDetail.feature.name,
        description: o.featureDetail.feature.description,
        tier: `${o.featureDetail.tierFrom || 0} - ${o.featureDetail.tierTo ||
          'infinity'}`,
        featureDetailId: `${o.featureDetail.id}`,
        discountedExtendedAmount: o.discountedExtendedAmount || 0,
        billingFrequency: o.billingFrequency,
        billingTreatment: o.featureDetail.cpqId,
        obligationId: o.itemId,
        endOfAgreementBehavior: o.endOfAgreementBehavior,
        quantity: o.quantity,
        entitlements: o.featureServiceRelationship,
        connectorName: o.connectorName,
        connectorId: o.connectorId
      };
    });

    const tableRef: any = React.createRef();
    return (
      <MaterialTable
        tableRef={tableRef}
        title="Obligations BA"
        columns={[
          { title: 'Delivery System', field: 'deliverySystem' },
          { title: 'ACCESS FROM', field: 'access' },
          { title: 'TERM', field: 'term' },
          { title: 'NAME', field: 'name' }
        ]}
        data={data}
        options={{
          grouping: true
        }}
        components={{
          Toolbar: props => (
            <div>
              <MTableToolbar {...props} />
              {!tableRef?.current?.dataManager?.grouped && (
                <div
                  style={{ padding: '10px 10px', backgroundColor: '#6F6F6F' }}
                >
                  <button
                    className="icon-trailing"
                    onClick={() => {
                      this.expandAllHandler(
                        tableRef,
                        (this.props as any).obligationSummaries.length
                      );
                    }}
                  >
                    Expand All <Icon name="arrow-down" />
                  </button>
                  <button
                    className="icon-trailing"
                    onClick={() => {
                      this.collapseAllHandler(
                        tableRef,
                        (this.props as any).obligationSummaries.length
                      );
                    }}
                  >
                    Collapse All <Icon name="arrow-right" />
                  </button>
                </div>
              )}
            </div>
          )
        }}
        detailPanel={rowData => (
          <div>
            <UsageTable
              usageData={(this.props as any).usageGraphQLData}
              featureDetail={(rowData as any).featureDetailId}
            />

            <ul style={{ padding: '10px' }}>
              <li>
                <b>Description: </b>
                {(rowData as any).description}
              </li>
              <li>
                <b>Tier: </b>
                {(rowData as any).tier}
              </li>
              <li>
                <b>Feature Detail Id: </b> {(rowData as any).featureDetailId}
              </li>
              <li>
                <b>Discounted Extended Amount:</b>
                {(rowData as any).discountedExtendedAmount}{' '}
              </li>
              <li>
                <b>Billing Frequency: </b>
                {(rowData as any).billingFrequency}{' '}
              </li>
              <li>
                <b>Billing Treatment: </b>
                <a
                  href={`./#/search?query=${(rowData as any).billingTreatment}`}
                >
                  {(rowData as any).billingTreatment}{' '}
                </a>
              </li>
              <li>
                <b>Obligation Id: </b>
                {(rowData as any).obligationId}{' '}
              </li>
              <li>
                <b>End Of Agreement Behavior: </b>
                {(rowData as any).endOfAgreementBehavior}{' '}
              </li>
              <li>
                <b>Quantity: </b>
                {(rowData as any).quantity}{' '}
              </li>
              <li>
                <b>Entitlements: </b>
                {(rowData as any).entitlements}{' '}
              </li>
              <li>
                <b>Connector: </b>
                <a
                  href={`${salesforceBaseURL}/${(rowData as any).connectorId}`}
                >
                  {(rowData as any).connectorName}{' '}
                  {(rowData as any).connectorId}
                </a>
              </li>
            </ul>
          </div>
        )}
      />
    );
  }
}
